import React from "react";
import { FormContext } from "./FormContext";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { TextareaAutosize } from "@mui/material";
import { XFormDesignerLayoutPanel } from "./XFormDesignerLayoutPanel";
import styled from "styled-components";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import { UIButton } from "../../CommonUI/BuildlingBlocks/UIButton";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

const TestDiv = styled.div`
    display: flex;
    flex-direction: row;
    min-height: 100px;
    width: 100%;
`;

const TestToolbox = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 236px;
    border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    border-radius: 0;
    height: 100%;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 15px;
    padding-bottom: 15px;

    @media (min-width: 1366px) {
        flex-basis: calc(236px + 59 * (100vw - 1366px) / 554);
        padding-left: calc(15px + 10 * (100vw - 1366px) / 554);
        padding-right: calc(15px + 15 * (100vw - 1366px) / 554);
    }

    @media (min-width: 1920px) {
        flex-basis: 295px;
        padding-left: 25px;
        padding-top: 29px;
        padding-right: 30px;
    }
`;

export class XUserFormTester extends React.Component<
    {
        editContext: FormContext;
    },
    {
        resultValue: string;
        height?: number;
    }
> {
    constructor(props: { editContext: FormContext }) {
        super(props);

        this.state = {
            resultValue: JSON.stringify(props.editContext.getFormData().values, null, 2),
        };

        // props.editContext.onFormDataChange = data => {
        //     this.setState({ 'resultValue': JSON.stringify(data, null, 2) });
        // }
    }

    componentDidUpdate() {
        const newFormValue = JSON.stringify(this.props.editContext.getFormData().values, null, 2);
        if (newFormValue !== this.state.resultValue) {
            this.setState({
                resultValue: newFormValue,
            });
        }
    }

    @AutoBind
    updateUI() {
        this.forceUpdate();
    }

    render() {
        //let form = new XUserForm({ form: this.props.form });

        return (
            <TestDiv>
                <TestToolbox>
                    <ObserveState
                        listenTo={this.props.editContext}
                        control={() => (
                            <TextareaAutosize
                                data-testid="runtime-json-textarea"
                                value={JSON.stringify(this.props.editContext.getFormData().values, null, 2)}
                                style={{
                                    width: "100%",
                                    border: "solid 1px " + UIStyleConstants.GRAY_LIGHTER_COLOR,
                                    borderRadius: "5px",
                                    color: UIStyleConstants.TEXT_COLOR_DEFAULT,
                                }}
                                minRows={20}
                            />
                        )}
                    />
                    <UIButton variant="contained">Save as Sample</UIButton>
                </TestToolbox>
                <XFormDesignerLayoutPanel editContext={this.props.editContext} />
            </TestDiv>
        );
    }
}
